// src/stone/illustrations/EasyTurningGrayIllustration.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var EasyTurningGrayIllustration = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 64 64",
    ...props,
    children: [
      /* @__PURE__ */ jsx("rect", { width: 64, height: 64, fill: "#E6ECF2", rx: 8 }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M37.84 21.72c0 .655-.074 1.296-.211 1.915a8.7 8.7 0 0 1-.51 1.598q-.135.326-.305.648-.095.195-.209.39c-.118.204-.24.406-.377.607a6 6 0 0 1-.252.359c-2.273 3.117-6.413 5.202-11.139 5.2H20.13l-.047-12.248-.036-7.99 1.177-.001 8.902-.284q.28.105.56.22.482.197.933.428-4.52.18-9.041.362c-.373.015-.366.493.008.48q4.922-.2 9.845-.398l.099.06c2.563 1.546 4.404 3.85 5.057 6.512.166.69.255 1.408.254 2.143"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#42EC9A",
          d: "M32.302 25.485c-2.537 5.538-10.035 8.34-16.748 6.261-1.756-.543-3.283-1.367-4.538-2.386a11 11 0 0 1-2.679-3.153l3.098-1.934a6.6 6.6 0 0 1-.375-1.154l-3.233 2.02a9 9 0 0 1-.247-.679l.042-.02 3.235-2.02.043-.599-.378.233-3.084 1.925a9 9 0 0 1-.267-1.636 9 9 0 0 1 .798-4.34c.01-.017.015-.034.024-.05 1.838-4.012 6.278-6.588 11.139-6.914q.453-.031.912-.034L24.811 11h.062c1.098 0 2.167.113 3.184.325q.697.147 1.357.35.359.112.71.24l-4.348.138q.776.305 1.478.683l4.364-.174q.006.001.01.004.415.208.802.44l-4.405.177c1.466.917 2.656 2.072 3.517 3.37 1.759 2.644 2.156 5.885.76 8.932"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FCFCFC",
          stroke: "#FCFCFC",
          d: "m14.06 26.689-.001-.001c-.885-.719-1.554-1.578-1.98-2.507a6 6 0 0 1-.2-.489l12.76-7.963q.356.175.684.375c1.003.613 1.809 1.386 2.387 2.25L14.188 26.79zM8.455 25.336l2.303-1.437q.029.086.06.17L8.53 25.498z"
        }
      ),
      /* @__PURE__ */ jsx("mask", { id: "easy-turning-gray_Illustration_svg__a", fill: "#fff", children: /* @__PURE__ */ jsx("path", { d: "m7.826 25.139.007.018z" }) }),
      /* @__PURE__ */ jsx("path", { fill: "#FCFCFC", d: "m7.826 25.139.007.018z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FCFCFC",
          d: "m7.826 25.139.945-.328-.233-.672h-.712zm.007.018-.887.462 1.832-.79zm-.008-.018v-1H6.42l.46 1.327zm-.944.327.008.021.004.01q0 .003 0 0l-.005-.012 1.89-.655-.011-.032v.002l.004.011zm1.84-.77a1 1 0 0 1 .049.115l-1.89.655q.02.061.066.153zm-.896 1.443h.001v-2z",
          mask: "url(#easy-turning-gray_Illustration_svg__a)"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M19.587 26.724c-.487 0-.99-.073-1.485-.22-1.842-.544-2.812-2.145-2.686-3.376.008-.076.088-.13.18-.126.093.006.161.074.153.149-.116 1.128.775 2.594 2.466 3.095 1.218.36 2.476.234 3.365-.336.671-.43 1.011-1.06.933-1.725-.148-1.257-1.087-1.808-2.277-2.504l-.11-.064c-1.215-.714-2.226-1.394-2.271-2.498-.03-.725.368-1.39 1.092-1.825.857-.516 2.048-.622 3.185-.286 1.354.4 2.09 1.391 2.328 2.185.023.074-.032.149-.122.167s-.181-.026-.203-.1c-.218-.725-.888-1.628-2.118-1.992-1.047-.31-2.096-.219-2.875.249-.633.38-.98.961-.955 1.592.041.98.95 1.59 2.132 2.284l.109.063c1.21.709 2.253 1.32 2.416 2.703.09.762-.296 1.48-1.06 1.97-.613.391-1.382.595-2.197.595"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M17.618 27.568a.2.2 0 0 1-.056-.008c-.088-.026-.133-.105-.102-.177l4.935-11.37c.031-.071.127-.109.214-.083s.133.105.102.176l-4.935 11.371c-.025.056-.088.091-.158.091"
        }
      ),
      /* @__PURE__ */ jsx("mask", { id: "easy-turning-gray_Illustration_svg__b", fill: "#fff", children: /* @__PURE__ */ jsx("path", { d: "m10.9 21.82-.044.599-3.234 2.02a.2.2 0 0 1-.042.02q-.08-.239-.142-.481l3.084-1.924z" }) }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FCFCFC",
          d: "m10.9 21.82-.044.599-3.234 2.02a.2.2 0 0 1-.042.02q-.08-.239-.142-.481l3.084-1.924z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FCFCFC",
          d: "m10.9 21.82.997.073.142-1.948-1.663 1.024zm-.044.599.53.848.431-.27.037-.506zm-3.234 2.02.526.85.004-.003zm-.042.02-.95.314.32.97.963-.34zm-.142-.481-.53-.849-.62.388.181.708zm3.084-1.924-.528-.85-.002.001zm-.62-.306-.043.598 1.995.145.043-.598zm.425-.178-3.234 2.02 1.059 1.697 3.234-2.02zm-3.23 2.018a1 1 0 0 1 .15-.072l.666 1.886a1.2 1.2 0 0 0 .235-.113zm1.433.558a6 6 0 0 1-.123-.415l-1.938.494q.073.282.161.548zm-.562.68 3.083-1.924-1.059-1.697L6.91 23.13zm3.082-1.923c.06-.037.152-.095.232-.143l.1-.062.03-.02.01-.004.001-.002h.001l-.524-.852-.524-.851-.003.001-.008.006-.031.018-.102.063-.238.148z",
          mask: "url(#easy-turning-gray_Illustration_svg__b)"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M13.765 27.371a.2.2 0 0 1-.115-.037c-1.06-.83-1.879-1.873-2.372-3.016a6.42 6.42 0 0 1-.245-4.521 7 7 0 0 1 .31-.808 7.6 7.6 0 0 1 1.636-2.288.19.19 0 0 1 .235-.016c.07.05.08.136.02.194a7.3 7.3 0 0 0-1.578 2.206q-.18.399-.299.78a6.2 6.2 0 0 0 .237 4.36c.475 1.1 1.266 2.107 2.287 2.907.067.053.07.14.006.195a.18.18 0 0 1-.122.044"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#42EC9A",
          d: "M46.545 25.787V52H9.525v-6.661H7v-6.382h2.528v-6.519H33.33v-6.65z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FCFCFC",
          stroke: "#FCFCFC",
          d: "M49.616 51.5V26.286h2.622V51.5zM47.045 51.5V26.286h.33V51.5z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#42EC9A",
          d: "M55.47 32.169v6.789H58v6.383h-2.53v6.658h-2.732V25.787H58v6.382zM49.116 25.787h-1.239V52h1.239z"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "#1D232A", d: "M33.33 38.688h-1.265v6.829h1.265z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M27.602 52h4.464V32.437h-1.199l-1.01 6.046-.118.713-1.01 6.045-.119.713z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M55.47 38.682v.275H9.517h.01v-.275zM55.47 32.162H33.33v.276h22.14zM55.47 45.34H9.524v.275h45.944z"
        }
      )
    ]
  }
);
var EasyTurningGrayIllustration_default = EasyTurningGrayIllustration;

export {
  EasyTurningGrayIllustration_default
};
